/* eslint-disable */

import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';

// material
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import {
  Box,
  Button,
  Typography,
  Container,
  Table,
  Card,
  CardActions,
  Chip,
  Grid,
  CardMedia,
  TableBody,
  TableCell,
  FormControl,
  Select,
  ToggleButton,
  ToggleButtonGroup,
  Snackbar,
  Alert,
  MenuItem,
  TableContainer,
  TableHead,
  TableRow,
  Stack,
  CircularProgress,
  Pagination,
  Tooltip,
  Paper
} from '@mui/material';

import { getTripStatusColor } from '../utils/Utilities';
import ConfirmAlertDialog from '../components/ConfirmDialog';
import { DeleteTripById, StartTripById, GetAllTripData } from '../network/Trip';
// components
import Page from '../components/Page';
import { EndTripModal, TripMoreMenu } from '../components/_dashboard/smartlock';
import CircleIcon from '@mui/icons-material/Circle';
import AddSmartLockNewTrip from '../components/_dashboard/smartlock/AddSmartLockNewTrip';
import {
  getEta,
  gridAlignmentType,
  HeaderHeight,
  PageHeaderHeight,
  tripStatus
} from '../Constants';
import UpdateDriverOnTrip from '../components/_dashboard/smartlock/UpdateDriverOnTrip';
import moment from 'moment';
import tripMap from '../icons/tripCard.png';
import useFeatures from '../components/customContextProviders/FeatureContext';
import Header from '../components/navbar/Header';
import { truncateText } from '../utils/Parser';
import { URL_CONSTANT } from '../URLConstants';
import NoDataAvailable from '../components/_dashboard/smartlock/NoDataAvailable';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

// ----------------------------------------------------------------------

const useStyles = makeStyles((theme) => ({
  toolTip: {
    backgroundColor: 'gray',
    color: '#ffffff'
  },
  menuItem: {
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    },
    minHeight: '20px',
    borderRadius: '8px',
    marginInline: theme.spacing(1)
  },
  tableCellStyle: {
    fontSize: {
      xs: '12px',
      md: '14px'
    },
    fontWeight: 700,
    padding: {
      xs: '8px',
      md: '16px'
    },
    backgroundColor: '#FFFFFF'
  },
  tablePaper: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    backgroundColor: '#FFFFFF'
  },
  tableContainer: {
    flexGrow: 1,
    height: `calc(100vh - ${HeaderHeight + PageHeaderHeight + 56 + 40 + 60 + 8}px)`,
    overflow: 'auto'
  }
}));

const PageHeader = styled('Box')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 1,
  flexDirection: 'row',
  height: '50px',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column'
  }
}));

export default function SmartLockTrips() {
  const navigate = useNavigate();
  const classes = useStyles();
  const location = useLocation();

  const feature = useFeatures();

  const tripType = location?.state?.trip || '';

  const [open, setOpen] = useState(false);
  const [tripDataList, setTripDataList] = useState([]);
  const [devicesListMetas, setDevicesListMetas] = useState({});
  const [devicesListLoading, setDevicesListLoading] = useState(false);
  const [sortFilterValue, setSortFilterValue] = useState(['created', 'DESC']);
  const [isEndTripModalVisible, setIsEndTripModalVisible] = useState(false);
  const [isEditDriverModalOpen, setIsEditDriverModalOpen] = useState(false);
  const [editDriverData, setEditDriverData] = useState({});
  const [isAddTripModal, setIsAddTripModal] = useState(false);
  const [showTripDetails, setShowTripDetails] = useState('');
  const [loader, setLoader] = useState(false);
  const [page, setPage] = useState(1);
  const [selectedTripData, setSelectedTripData] = useState({});
  const [openConfirmAlertDialog, setOpenConfirmAlertDialog] = useState(false);
  const [gridListAlignment, setGridListAlignment] = useState('GRID');
  const [filterByValue, setFilterByValue] = useState('');
  const [tripPagination, setTripPagination] = useState([]);
  const [search, setSearch] = useState('');
  const [confirmAlertDialogMetas, setConfirmAlertDialogMetas] = useState({
    message: '',
    title: '',
    positiveBtnLable: '',
    negativeBtnLabel: ''
  });

  const [alertMetas, setAlertMetas] = useState({
    snackBarOpened: false,
    vertical: 'top',
    horizontal: 'right',
    msg: '',
    variant: 'filled',
    severity: ''
  });
  const [initialRender, setInitialRender] = useState(false);

  const vertical = 'bottom';
  const horizontal = 'left';

  const handlePageChange = (event, value) => {
    setPage(value);
  };
  const handleGridListViewChange = (event, newAlignment) => {
    if (newAlignment !== null) {
      setGridListAlignment(newAlignment);
    }
  };

  const handleChange = (event, newAlignment) => {
    if (newAlignment !== null) {
      setFilterByValue(newAlignment);
    }
  };

  const handleSortFilterChnage = (event) => {
    const value = event.target.value.split(',');
    setSortFilterValue(value);
  };

  const getAllTrips = async (page, search, sortFilterValue, filterByValue) => {
    setLoader(true);
    setDevicesListLoading(true);

    try {
      const res = await GetAllTripData(page, search, sortFilterValue, filterByValue);
      setTripPagination(res?.data);
      setTripDataList(res?.data?.data);
    } catch (err) {
      console.error('Failed to fetch trip data:', err);
    } finally {
      setLoader(false);
      setDevicesListLoading(false);
    }
  };

  const deleteTripById = async (tripId) => {
    try {
      const res = await DeleteTripById(tripId);
      setAlertMetas({
        ...alertMetas,
        severity: 'error',
        snackBarOpened: true,
        msg: res?.data?.data
      });
      setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
    } catch (err) {
      setAlertMetas({
        ...alertMetas,
        severity: 'error',
        snackBarOpened: true,
        msg: err?.response?.data?.message
      });
      setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
    } finally {
      handleTripData();
    }
  };

  const handleUserMoreMenuClick = (action, tripData) => {
    switch (action) {
      case 'end_trip': {
        setSelectedTripData(tripData);
        setIsEndTripModalVisible(true);
        break;
      }
      case 'start_trip': {
        handleTripStart(tripData?.trip?.id, 'Trip Started');
        break;
      }
      case 'delete_trip': {
        setSelectedTripData(tripData);
        setConfirmAlertDialogMetas({
          ...confirmAlertDialogMetas,
          message: 'Are you sure want to delete this trip ?',
          title: 'Delete',
          positiveBtnLable: 'Confirm',
          negativeBtnLabel: 'Cancel'
        });
        setOpenConfirmAlertDialog(true);
        break;
      }
      case 'edit_driver': {
        setEditDriverData((editDriverData) => tripData?.trip);
        setIsEditDriverModalOpen(true);
        break;
      }
      default: {
        return;
      }
    }
  };

  const handleTripStart = async (id, msg) => {
    const payload = {
      note: msg
    };

    try {
      const res = await StartTripById(id, payload);
      setAlertMetas({
        ...alertMetas,
        severity: 'success',
        snackBarOpened: true,
        msg: 'Trip Started Successfully!'
      });
      setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
      handleTripData();
    } catch (err) {
      setAlertMetas({
        ...alertMetas,
        severity: 'error',
        snackBarOpened: true,
        msg: err?.response?.data?.message
      });
      setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
    }
  };

  function goToTripDetails(tripData) {
    navigate(URL_CONSTANT.TRIP_DETAIL, { state: { tripData: tripData?.trip } });
  }

  const handleTripData = (msg, action) => {
    getAllTrips(page, search, sortFilterValue, filterByValue);
  };

  const handleTripSearch = (value) => {
    setSearch(value);
  };

  const searchTrip = () => {
    setPage(1);
    getAllTrips(page, search, sortFilterValue, filterByValue);
  };

  const getTripEtaLabel = (data) => {
    if (data?.trip?.status?.toUpperCase() === tripStatus?.TRIP_SCHEDULED?.toUpperCase()) {
      return tripStatus?.TRIP_SCHEDULED?.toLowerCase().replace(/\b\w/g, (char) =>
        char.toUpperCase()
      );
    } else if (data?.trip?.status?.toUpperCase() === tripStatus?.TRIP_STARTED?.toUpperCase()) {
      const etaSeconds = data?.route?.eta ?? 0;
      const etaHours = Math.floor(etaSeconds / 3600);
      const etaMinutes = Math.floor((etaSeconds % 3600) / 60);
      if (!isNaN(etaHours) && !isNaN(etaMinutes)) {
        return `ETA: ${etaHours} hrs ${etaMinutes} mins`;
      } else {
        return 'ETA: Unknown';
      }
    } else if (data?.trip?.status?.toUpperCase() === tripStatus.TRIP_COMPLETED?.toUpperCase()) {
      return tripStatus.TRIP_COMPLETED?.toLowerCase().replace(/\b\w/g, (char) =>
        char.toUpperCase()
      );
    }
  };

  const getTripTextColor = (data) => {
    if (data?.trip?.status?.toUpperCase() === tripStatus.TRIP_SCHEDULED?.toUpperCase())
      return '#000000';
    else if (data?.trip?.status?.toUpperCase() === tripStatus.TRIP_STARTED?.toUpperCase())
      return '#C30A0A';
    else if (data?.trip?.status?.toUpperCase() === tripStatus.TRIP_COMPLETED?.toUpperCase())
      return '#54D62C';
    else return '';
  };

  useEffect(() => {
    if (tripType) {
      setFilterByValue(tripType);
    }
    setInitialRender(true);
  }, [tripType]);

  useEffect(() => {
    if (initialRender) {
      getAllTrips(page, search, sortFilterValue, filterByValue);
    }
    return () => {
      setTripDataList((tripDataList) => []);
    };
  }, [page, search, sortFilterValue, filterByValue, initialRender]);

  return (
    <Page title="Trips">
      <Header
        onOpenSidebar={() => setOpen(true)}
        handleSearch={handleTripSearch}
        handleSubmit={searchTrip}
        name="Trip Management"
        showSearch={true}
      />
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={alertMetas?.snackBarOpened}
        // onClose={handleSnackBarClose}
        autoHideDuration={6000}
      >
        <Alert variant={alertMetas?.variant} severity={alertMetas?.severity}>
          {alertMetas?.msg}
        </Alert>
      </Snackbar>

      <Container maxWidth="false" disableGutters sx={{ padding: 0 }}>
        <PageHeader sx={{ display: 'flex', flexDirection: { xs: 'row' } }}>
          <Box>
            {feature?.trip?.addTrip && (
              <Button
                variant="outlined"
                size="medium"
                onClick={() => setIsAddTripModal(true)}
                sx={{ backgroundColor: '#FFFFFF', boxShadow: '0px 10px 19px 1px #EAEAFF' }}
              >
                Add Trip
              </Button>
            )}
          </Box>

          <ToggleButtonGroup
            sx={{
              '& .Mui-selected': {
                color: '#171D40 !important',
                fontWeight: '700 !important',
                backgroundColor: '#FFF !important'
              },
              '& .MuiToggleButton-root:hover': {
                color: '#171D40 !important'
              },
              '& .MuiToggleButton-root': {
                // border: '1px solid #B0B9C7',
                backgroundColor: '#FFF ',
                textAlign: 'center',
                fontFamily: 'Mulish',
                fontSize: { xs: '12px', sm: '14px' },
                fontStyle: 'normal',
                fontWeight: 600,
                lineHeight: 'normal',
                color: '#B0B9C7',
                padding: '8px'
              }
            }}
            color="primary"
            value={gridListAlignment}
            size="small"
            exclusive
            onChange={handleGridListViewChange}
            aria-label="Platform"
          >
            <ToggleButton sx={{ minWidth: 50 }} value="GRID">
              Grid
            </ToggleButton>
            <ToggleButton sx={{ minWidth: 50 }} value="LIST">
              List
            </ToggleButton>
          </ToggleButtonGroup>
        </PageHeader>

        <Card sx={{ width: '100%', mb: 1 }}>
          <PageHeader
            sx={{
              px: 2,
              py: { xs: 1, sm: 0 },
              height: { xs: '90px', sm: '60px' },
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: { xs: 1, sm: 0 }
            }}
          >
            <Stack direction="row" spacing={2} alignItems="center" justifyContent="flex-start">
              <FormControl data-testid="trip-sort-by" size="small">
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Typography sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: 600 }}>
                    Sort By
                  </Typography>
                  <Select
                    sx={{
                      fontSize: { xs: '12px', sm: '14px' },
                      fontWeight: '500',
                      minWidth: '130px',
                      borderRadius: '12px'
                    }}
                    id="route_sort_filter"
                    value={sortFilterValue.join(',')}
                    onChange={handleSortFilterChnage}
                    IconComponent={ExpandMoreIcon}
                  >
                    <MenuItem className={classes.menuItem} value="name,ASC">
                      Trip Name
                    </MenuItem>
                    <MenuItem className={classes.menuItem} value="created,DESC">
                      Most Recent{' '}
                    </MenuItem>
                    <MenuItem className={classes.menuItem} value="distance,ASC">
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          width: '100%'
                        }}
                      >
                        <Typography sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: 500 }}>
                          Route Length
                        </Typography>{' '}
                        <ExpandMoreIcon data-testid="trip-expand-more" />
                      </Box>
                    </MenuItem>
                    <MenuItem className={classes.menuItem} value="distance,DESC">
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          width: '100%'
                        }}
                      >
                        <Typography sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: 500 }}>
                          Route Length
                        </Typography>{' '}
                        <ExpandLessIcon data-testid="trip-expand-less" />
                      </Box>
                    </MenuItem>
                    <MenuItem className={classes.menuItem} value="eta,ASC">
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          width: '100%'
                        }}
                      >
                        <Typography sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: 500 }}>
                          ETA
                        </Typography>{' '}
                        <ExpandMoreIcon data-testid="trip-expand-more-eta" />
                      </Box>
                    </MenuItem>
                    <MenuItem className={classes.menuItem} value="eta,DESC">
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          width: '100%'
                        }}
                      >
                        <Typography sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: 500 }}>
                          ETA
                        </Typography>{' '}
                        <ExpandLessIcon data-testid="trip-expand-less-eta" />
                      </Box>
                    </MenuItem>
                  </Select>
                </Box>
              </FormControl>
            </Stack>

            <Stack direction="row" spacing={2} alignItems="center" justifyContent="flex-end">
              <ToggleButtonGroup
                sx={{
                  '& .Mui-selected': {
                    color: '#171D40 !important',
                    fontWeight: '700 !important',
                    backgroundColor: '#FFF !important'
                  },
                  '& .MuiToggleButton-root:hover': {
                    color: '#171D40 !important'
                  },
                  '& .MuiToggleButton-root': {
                    // border: '1px solid #B0B9C7',
                    backgroundColor: '#FFF',
                    textAlign: 'center',
                    fontFamily: 'Mulish',
                    fontSize: { xs: '12px', sm: '14px' },
                    fontStyle: 'normal',
                    fontWeight: 600,
                    lineHeight: 'normal',
                    color: '#B0B9C7',
                    padding: '8px'
                  }
                }}
                color="primary"
                value={filterByValue}
                size="small"
                exclusive
                onChange={handleChange}
                aria-label="Platform"
              >
                <ToggleButton value="" sx={{ minWidth: 40 }}>
                  All
                </ToggleButton>
                <ToggleButton value="STARTED" sx={{ minWidth: 40 }}>
                  Live
                </ToggleButton>
                <ToggleButton
                  data-testid="previous-trip-button"
                  value="COMPLETED"
                  sx={{ minWidth: 40 }}
                >
                  Previous
                </ToggleButton>
                <ToggleButton value="SCHEDULED" sx={{ minWidth: 40 }}>
                  Scheduled
                </ToggleButton>
              </ToggleButtonGroup>
            </Stack>
          </PageHeader>
        </Card>
        {loader ? (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <CircularProgress size={30} />
          </div>
        ) : (
          <>
            {gridListAlignment === gridAlignmentType.TYPE_LIST && (
              <Card>
                <Paper className={classes.tablePaper}>
                  <TableContainer
                    data-testid="trip-table-container"
                    className={classes.tableContainer}
                  >
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="left" width={150} className={classes.tableCellStyle}>
                            Trip
                          </TableCell>
                          <TableCell width={200} className={classes.tableCellStyle}>
                            Route
                          </TableCell>
                          <TableCell align="left" width={200} className={classes.tableCellStyle}>
                            Status
                          </TableCell>
                          <TableCell align="left" width={130} className={classes.tableCellStyle}>
                            <Tooltip title="Actual Time of Departure" placement="top">
                              <span>ATD</span>
                            </Tooltip>
                          </TableCell>
                          <TableCell align="left" width={130} className={classes.tableCellStyle}>
                            <Tooltip title="Actual Time of Arrival" placement="top">
                              <span>ATA</span>
                            </Tooltip>
                          </TableCell>
                          <TableCell align="left" width={150} className={classes.tableCellStyle}>
                            <Tooltip title="Estimate Time of Arrival" placement="top">
                              <span>ETA</span>
                            </Tooltip>
                          </TableCell>
                          <TableCell align="left" width={150} className={classes.tableCellStyle}>
                            Vehicle
                          </TableCell>
                          <TableCell align="left" className={classes.tableCellStyle}></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {tripDataList?.length === 0 ? (
                          <TableRow>
                            <TableCell colSpan={10}>
                              <NoDataAvailable data-testid="no-data-available" />
                            </TableCell>
                          </TableRow>
                        ) : (
                          tripDataList?.map((row, index) => (
                            <TableRow
                              key={index}
                              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                              <TableCell
                                align="left"
                                sx={{
                                  minWidth: '5vw',
                                  textWrap: 'nowrap',
                                  textTransform: 'capitalize',
                                  padding: {
                                    xs: '8px',
                                    md: '16px'
                                  },
                                  fontSize: {
                                    xs: '12px',
                                    md: '14px' // Larger screens
                                  }
                                }}
                              >
                                <RouterLink
                                  to={URL_CONSTANT.TRIP_DETAIL}
                                  state={{ tripData: row?.trip }}
                                  style={{ textDecoration: 'none', color: '#212B36' }}
                                >
                                  <Tooltip placement="top" title={row?.trip?.name}>
                                    {truncateText(row?.trip?.name, 30)}
                                  </Tooltip>
                                </RouterLink>
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{
                                  minWidth: '5vw',
                                  textWrap: 'nowrap',
                                  textTransform: 'capitalize',
                                  padding: {
                                    xs: '8px',
                                    md: '16px'
                                  },
                                  fontSize: {
                                    xs: '12px',
                                    md: '14px' // Larger screens
                                  }
                                }}
                              >
                                {row?.route?.name}
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{
                                  minWidth: '5vw',
                                  textWrap: 'nowrap',
                                  textTransform: 'capitalize',
                                  padding: {
                                    xs: '8px',
                                    md: '16px'
                                  },
                                  fontSize: {
                                    xs: '12px',
                                    md: '14px' // Larger screens
                                  }
                                }}
                              >
                                {row?.trip?.status !== undefined &&
                                row?.trip?.status !== null &&
                                row?.trip?.trip_status !== '' ? (
                                  <>
                                    <CircleIcon
                                      color={getTripStatusColor(row?.trip?.status)}
                                      sx={{ fontSize: '10px', marginRight: '5px' }}
                                    />
                                    {row.trip.status}
                                  </>
                                ) : (
                                  <Typography>--</Typography>
                                )}
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{
                                  minWidth: '5vw',
                                  textWrap: 'nowrap',
                                  textTransform: 'capitalize',
                                  padding: {
                                    xs: '8px',
                                    md: '16px'
                                  },
                                  fontSize: {
                                    xs: '12px',
                                    md: '14px' // Larger screens
                                  }
                                }}
                              >
                                {row?.trip?.end_time
                                  ? moment(row?.trip?.start_time).format('DD-MM-YY hh:mm:ss')
                                  : '--'}
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{
                                  minWidth: '5vw',
                                  textWrap: 'nowrap',
                                  textTransform: 'capitalize',
                                  padding: {
                                    xs: '8px',
                                    md: '16px'
                                  },
                                  fontSize: {
                                    xs: '12px',
                                    md: '14px' // Larger screens
                                  }
                                }}
                              >
                                {row?.trip?.end_time
                                  ? moment(row?.trip?.end_time).format('DD-MM-YY hh:mm:ss')
                                  : '--'}
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{
                                  minWidth: '5vw',
                                  textWrap: 'nowrap',
                                  textTransform: 'capitalize',
                                  padding: {
                                    xs: '8px',
                                    md: '16px'
                                  },
                                  fontSize: {
                                    xs: '12px',
                                    md: '14px' // Larger screens
                                  }
                                }}
                              >
                                {' '}
                                {getEta(row?.route?.eta)}
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{
                                  minWidth: '5vw',
                                  textWrap: 'nowrap',
                                  textTransform: 'capitalize',
                                  padding: {
                                    xs: '8px',
                                    md: '16px'
                                  },
                                  fontSize: {
                                    xs: '12px',
                                    md: '14px' // Larger screens
                                  }
                                }}
                              >
                                {' '}
                                {row?.vehicle?.name}
                              </TableCell>
                              {Object.values(feature?.trip).some((value) => value) && (
                                <TableCell
                                  align="right"
                                  sx={{
                                    padding: {
                                      xs: '8px',
                                      md: '16px'
                                    }
                                  }}
                                >
                                  <TripMoreMenu
                                    tripData={row}
                                    handleClicks={(e) => handleUserMoreMenuClick(e, row)}
                                  />
                                </TableCell>
                              )}
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>

                {tripPagination?.data?.length !== 0 && (
                  <Stack
                    sx={{
                      marginTop: '10px',
                      marginBottom: '10px'
                    }}
                  >
                    <Pagination
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end'
                      }}
                      count={tripPagination?.totalPages}
                      showFirstButton
                      showLastButton
                      onChange={handlePageChange}
                      page={page}
                      total={tripPagination?.total}
                    />
                  </Stack>
                )}
              </Card>
            )}

            {gridListAlignment === gridAlignmentType.TYPE_GRID && (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: `calc(100vh - ${HeaderHeight + PageHeaderHeight + 40 + 60 + 8}px)`
                }}
              >
                <Grid data-testid="trips-grid-container" container spacing={2}>
                  {tripDataList?.length === 0 ? (
                    <NoDataAvailable />
                  ) : (
                    tripDataList?.map((row, index) => (
                      <Grid item key={index} xs={6} sm={4} md={3} lg={2.4}>
                        <Card
                          sx={{
                            minHeight: 280,
                            height: '100%',
                            maxHeight: 'max-content',
                            display: 'flex',
                            flexDirection: 'column',
                            position: 'relative'
                          }}
                        >
                          <CardMedia
                            sx={{ height: 120, cursor: 'pointer' }}
                            component="img"
                            image={tripMap}
                            alt="map"
                            title="trip map"
                            onClick={() => goToTripDetails(row)}
                          />

                          <Chip
                            size="small"
                            label={getTripEtaLabel(row)}
                            sx={{
                              color: getTripTextColor(row),
                              fontSize: '12px',
                              fontStyle: 'normal',
                              fontWeight: 600,
                              ml: 1,
                              position: 'absolute',
                              top: '2%',
                              background: 'white'
                            }}
                          />
                          {Object.values(feature?.trip).some((value) => value) && (
                            <TripMoreMenu
                              sx={{
                                position: 'absolute',
                                top: '1%',
                                right: '0%',
                                color: 'white'
                              }}
                              tripData={row}
                              handleClicks={(e) => handleUserMoreMenuClick(e, row)}
                            />
                          )}
                          {showTripDetails === index + 'show' ? (
                            <Box
                              sx={{
                                p: 2,
                                position: 'absolute',
                                width: '100%',
                                top: '20%',
                                backgroundColor: '#F8FAFB',
                                height: '80%',
                                display: 'flex',
                                flexDirection: 'column',
                                overflow: 'scroll'
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: 12,
                                  fontWeight: 600,
                                  lineHeight: '20px',
                                  color: '#171D40',
                                  textTransform: 'capitalize'
                                }}
                              >
                                {row?.trip?.name}
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: 12,
                                  fontWeight: 600,
                                  lineHeight: '20px',
                                  color: '#6F6F6F'
                                }}
                              >
                                Date Created: {moment(row?.trip?.created_at).format('DD/MM/YY')}
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: 12,
                                  fontWeight: 600,
                                  lineHeight: '20px',
                                  color: '#6F6F6F',
                                  textTransform: 'capitalize'
                                }}
                              >
                                Driver: {row?.trip?.driver_name}
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: 12,
                                  fontWeight: 600,
                                  lineHeight: '20px',
                                  color: '#6F6F6F'
                                }}
                              >
                                Mobile: {row?.trip?.driver_phone}
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: 12,
                                  fontWeight: 600,
                                  lineHeight: '20px',
                                  color: '#6F6F6F',
                                  textTransform: 'capitalize'
                                }}
                              >
                                Vehicle: {row?.vehicle?.registration_no}
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: 12,
                                  fontWeight: 600,
                                  lineHeight: '20px',
                                  color: '#6F6F6F'
                                }}
                              >
                                Type: {row?.vehicle?.type?.toUpperCase()}
                              </Typography>

                              <Button
                                size="small"
                                sx={{ mt: 'auto', width: 'max-content' }}
                                variant="outlined"
                                onClick={() => setShowTripDetails(index + 'hide')}
                              >
                                Less Details
                              </Button>
                            </Box>
                          ) : (
                            <Box
                              sx={{
                                p: 2,
                                display: 'flex',
                                flexDirection: 'column',
                                height: '100%'
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: { xs: 12, sm: 14 },
                                  fontWeight: 700,
                                  color: '#171D40',
                                  textTransform: 'capitalize'
                                }}
                              >
                                {row?.trip?.name}
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: { xs: 12, sm: 14 },
                                  fontWeight: 600,
                                  color: '#171D40',
                                  textTransform: 'capitalize'
                                }}
                              >
                                {row?.route?.name}
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: { xs: 12, sm: 14 },
                                  fontWeight: 600,
                                  color: '#6F6F6F'
                                }}
                              >
                                Date Created: {moment(row?.trip?.created_at).format('DD/MM/YY')}
                              </Typography>
                              <Button
                                sx={{ mt: 'auto', width: 'max-content' }}
                                size="small"
                                variant="outlined"
                                onClick={() => setShowTripDetails(index + 'show')}
                              >
                                More Details
                              </Button>
                            </Box>
                          )}
                        </Card>
                      </Grid>
                    ))
                  )}
                </Grid>
                {tripPagination?.data?.length !== 0 && (
                  <Pagination
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      marginTop: 'auto'
                    }}
                    count={tripPagination?.totalPages}
                    showFirstButton
                    showLastButton
                    onChange={handlePageChange}
                    page={page}
                    total={tripPagination?.total}
                    sx={{
                      '& .MuiPaginationItem-root': {
                        padding: '8px',
                        minWidth: {
                          xs: '24px',
                          md: '24px'
                        },
                        height: {
                          xs: '24px',
                          md: '24px'
                        },
                        fontSize: {
                          xs: '12px',
                          md: '14px'
                        }
                      }
                    }}
                  />
                )}
              </Box>
            )}
          </>
        )}

        <EndTripModal
          tripId={selectedTripData?.trip?.id}
          openAssignedModal={isEndTripModalVisible}
          handleClose={() => setIsEndTripModalVisible(false)}
          onAction={(msg, action) => handleTripData(msg, action)}
          alertMetas={alertMetas}
          setAlertMetas={setAlertMetas}
        />
        <UpdateDriverOnTrip
          openAssignedModal={isEditDriverModalOpen}
          driverData={editDriverData}
          handleClose={() => setIsEditDriverModalOpen(false)}
          onAction={(msg, action) => handleTripData(msg, action)}
          alertMetas={alertMetas}
          setAlertMetas={setAlertMetas}
        />
        {isAddTripModal && (
          <AddSmartLockNewTrip
            openAssignedModal={isAddTripModal}
            handleClose={() => setIsAddTripModal(false)}
            onAction={(msg, action) => handleTripData(msg, action)}
            alertMetas={alertMetas}
            setAlertMetas={setAlertMetas}
          />
        )}
        <ConfirmAlertDialog
          openConfirmAlertDialog={openConfirmAlertDialog}
          message={confirmAlertDialogMetas?.message}
          title={confirmAlertDialogMetas?.title}
          positiveBtnLable={confirmAlertDialogMetas?.positiveBtnLable}
          negativeBtnLable={confirmAlertDialogMetas?.negativeBtnLabel}
          handleClose={() => setOpenConfirmAlertDialog(false)}
          handlePositiveClose={() => {
            deleteTripById(selectedTripData?.trip?.id);
            setOpenConfirmAlertDialog(false);
          }}
          handleNegativeClose={() => setOpenConfirmAlertDialog(false)}
        />
      </Container>
    </Page>
  );
}
